// extracted by mini-css-extract-plugin
export var games = "gamesList-module--games--zamho";
export var game = "gamesList-module--game--dlIE2";
export var gameBody = "gamesList-module--gameBody--j-82W";
export var tip = "gamesList-module--tip--LUY8r";